import { ReportData } from '@/components/preview/types';
import { SECTIONS } from '@/components/wizard/constants';
import DemandaStep from '@/components/wizard/DemandaStep';
import DiagnosisStep from '@/components/wizard/DiagnosisStep';
import HistoriaClinicaStep from '@/components/wizard/HistoriaClinicaStep';
import ObservationsStep from '@/components/wizard/ObservationsStep';
import PatientInfoStep from '@/components/wizard/PatientInfoStep';
import ProceduresStep from '@/components/wizard/ProceduresStep';
import RecommendationsStep from '@/components/wizard/RecommendationsStep';
import TestScoresStep from '@/components/wizard/TestScoresStep';
import { WizardStep } from '@/components/wizard/types';
import { DEFAULT_FONT, DEFAULT_PRIMARY_COLOR, DEFAULT_SECONDARY_COLOR } from '@/constants';

export const STEPS: WizardStep[] = [
    {
        id: SECTIONS.PATIENT,
        title: 'Informações do Paciente',
        component: PatientInfoStep,
        description:
            'Os dados de identificação que abrem o documento e situam quem foi avaliado, por quem e em que contexto.',
    },
    {
        id: SECTIONS.DEMAND_DESCRIPTION,
        title: 'Descrição da Demanda',
        component: DemandaStep,
        description:
            'Explica por que a avaliação foi solicitada, com a queixa principal descrita nas palavras de quem procurou você.',
    },
    {
        id: SECTIONS.PROCEDURES,
        title: 'Procedimentos',
        component: ProceduresStep,
        description:
            'Lista sessões, entrevistas e instrumentos usados, dando transparência ao método e mostrando em que sua conclusão se apoia.',
    },
    {
        id: SECTIONS.BEHAVIOR_OBSERVATIONS,
        title: 'Observação do Comportamento',
        component: ObservationsStep,
        description:
            'Como o paciente se apresentou nos encontros: humor, atenção, cooperação e ritmo ajudam a interpretar os resultados.',
    },
    {
        id: SECTIONS.CLINICAL_HISTORY,
        title: 'História Clínica',
        component: HistoriaClinicaStep,
        description:
            'A trajetória do paciente em desenvolvimento, saúde, escola e família, o pano de fundo que dá sentido aos achados.',
    },
    {
        id: SECTIONS.TESTS,
        title: 'Análise',
        component: TestScoresStep,
        description:
            'Os instrumentos aplicados e o desempenho obtido, apresentados de forma interpretativa e não como uma lista de números soltos.',
    },
    {
        id: SECTIONS.DIAGNOSIS,
        title: 'Diagnóstico e Conclusão',
        component: DiagnosisStep,
        description:
            'Responde à demanda inicial integrando as evidências do caso; o CID ou DSM entra como complemento, nunca sozinho.',
    },
    {
        id: SECTIONS.RECOMMENDATIONS,
        title: 'Recomendações',
        component: RecommendationsStep,
        description:
            'O que fazer com o que foi encontrado: encaminhamentos, ajustes na escola ou no trabalho e orientações à família.',
    },
];

export const INITIAL_FORM_DATA: Partial<ReportData> = {
    status: 'in_progress',
    section_order: undefined,
    custom_sections: [],
    tests: {
        section_title: 'Análise',
        blocks: [],
    },
    customizations: {
        header: {
            alignment: 'left',
            show_psychologist_name: true,
            show_crp_number: true,
            show_logo: false,
            show_letterhead: false,
            description: {
                showing: false,
                value: '',
            },
        },
        footer: {
            phone_number_visible: true,
            psychologist_name_visible: true,
            email_visible: true,
            instagram_visible: true,
            padding: 12,
        },
        font: {
            family: DEFAULT_FONT,
        },
        colors: {
            primary: DEFAULT_PRIMARY_COLOR,
            secondary: DEFAULT_SECONDARY_COLOR,
        },
        divider: {
            alignment: 'center',
            background_color: 'primary',
            show_line: true,
            font_style: 'normal',
        },
    },
};
